// extracted by mini-css-extract-plugin
export var form = "_fk-0";